<template>
  <a-form
    ref="form"
    autocomplete="off"
    :model="model"
    :rules="form.rules"
    scrollToFirstError
  >
    <a-row
      gutter="5"
      v-for="row in form.fieldList"
      type="flex"
    >
      <a-col
        v-for="field in row"
        :span="field.span"
      >
        <template v-for="field in form.fields">
          <field-render
            v-model:value="model[field.name]"
            v-model:label="model[field.name2]"
            v-if="field.name2"
            :field="field"
            :formModel="model"
            :key="field.name"
            :validateInfos="validateInfos"
            :options="options[field.datasource ? field.datasource : field.name]"
          />
          <field-render
            v-model:value="model[field.name]"
            v-else
            :field="field"
            :formModel="model"
            :key="field.name"
            :validateInfos="validateInfos"
            :options="options[field.datasource ? field.datasource : field.name]"
          />
        </template>
      </a-col>
    </a-row>
  </a-form>
</template>
<script lang="ts">
import { defineComponent, watch } from 'vue';

export default defineComponent({
  name: 'FormRender2',
  components: {},
  props: {
    model: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    validateInfos: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    if (props.form.watch) {
      for (const k in props.form.watch) {
        watch(
          () => props.model[k],
          () => {
            props.form.watch[k](props.model, props.form);
          },
        );
      }
    }
  },

  data() {
    return {};
  },
  methods: {
    validate() {
      return (this.$refs.form as any).validate();
    },
    reset() {
      (this.$refs.form as any).resetFields();
    },
    disable(name: string | number) {
      // eslint-disable-next-line vue/no-mutating-props
      this.form.fields[name].disabled = true;
    },
    disableAll() {
      this.form.fields.forEach((item: any) => {
        item.disabled = true;
      });
    },
  },
  created() {},
});
</script>
